"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconEyeSlash = function SvgIconEyeSlash(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "eye slash icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Eye Slash Icon'), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "null",
    strokeWidth: 0.836,
    d: "M4.758 43.267A2.488 2.488 0 006.523 44c.64 0 1.279-.245 1.765-.733L43.242 8.268a2.5 2.5 0 000-3.535 2.492 2.492 0 00-3.53 0l-6.854 6.862C30.28 10.078 27.323 9.001 24 9.001 12.128 9 4.653 22.223 4.341 22.785c-.422.758-.42 1.68.005 2.438.175.312 2.607 4.505 6.724 8.19l-6.314 6.322a2.499 2.499 0 00.002 3.532zm4.714-19.27C11.412 21.088 16.875 14 24 14c1.853 0 3.588.503 5.188 1.27l-3.91 3.915A4.8 4.8 0 0024 19a4.995 4.995 0 00-4.993 5c0 .445.072.87.185 1.28l-4.58 4.585c-2.384-2.09-4.196-4.46-5.14-5.867zm30.941-5.824c1.993 2.405 3.124 4.395 3.241 4.607.427.76.425 1.69-.002 2.45C43.335 25.79 35.752 39 24 39a15.93 15.93 0 01-3.887-.5l4.531-4.537c6.769-.413 11.987-7.138 13.884-9.963-.407-.607-.976-1.4-1.67-2.267z"
  }));
};

var _default = SvgIconEyeSlash;
exports.default = _default;